import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@application/config';
import { Observable } from 'rxjs';
import { IQuickAnswer } from '../entities/helpdesk.interface';

@Injectable({
  providedIn: 'root',
})
export class SettingsHelpdeskService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(APP_CONFIG).apiUrl;

  public getQuickAnswer(id: string): Observable<IQuickAnswer> {
    return this.http
      .get<IQuickAnswer> (`${this.apiUrl.helpdesk}/Tickets/ObterRespostaRapidaPorId`, {
        withCredentials: true,
        params: {
          id,
        },
      });
  }

   public createQuickAnswer(payload: IQuickAnswer): Observable<{}> {
    return this.http.post(`${this.apiUrl.helpdesk}/Tickets/AdicionarRespostaRapida`, payload, {
      withCredentials: true,
    });
  }

  public updateQuickAnswer(payload: IQuickAnswer): Observable<{}> {
    return this.http.post(`${this.apiUrl.helpdesk}/Tickets/AtualizarRespostaRapida`, payload, {
      withCredentials: true,
    });
  }

  public deleteQuickAnswer(id: string): Observable<{}> {
    return this.http.delete(`${this.apiUrl.helpdesk}/Tickets/RemoverRespostaRapida`, {
      withCredentials: true,
      params: {
        id,
      },
    });
  }
}
